<template>
<div>
    <div class="container" v-show="quiz">
      <div class="heading-content-title">
        <template v-if="step=='listening_practice'">{{ $t('lesson.listening_practice.title') }}</template>
        <template v-else-if="step=='exam'">{{ $t('lesson.exam.title') }}</template>
        <template v-else>{{ $t('lesson.question.title') }}</template>
        <div class="heading-content-right" v-for="(question,index) in questionList" :key="index" v-show="quiz">
          <div class="progress">{{b}}/{{questions.length}}</div>
          <!-- Lives -->
          <div class="lives">
            <div class="icon-life" :class="(lives_cnt >= 1) ? 'star-available' : 'star-spent'"></div>
            <div class="icon-life" :class="(lives_cnt >= 2) ? 'star-available' : 'star-spent'"></div>
            <div class="icon-life" :class="(lives_cnt >= 3) ? 'star-available' : 'star-spent'"></div>
          </div>
        </div>
      </div>

      <div class="quiz-box" v-for="(question,index) in questionList" :key="index" v-show="quiz">


        <!-- Question -->
        <div class="questions-combined">
          <div class="box-question-explanation" @click="changeTrans(selectedLanguage.key)">
            <p v-show="!trans_instruction" v-html="question.instruction"></p>
            <p v-show="trans_instruction" v-html="question[selectedLanguage.key + '_instruction']"></p>
          </div>

          <div class="box-question">
            <p v-html="question.question"></p>
          </div>
        </div>

        <!-- Answer Choices -->
        <div class="box-propositions">
          <ul>
            <li v-for="(proposition,index) in question.propositions" :key="index" class="button button-choice" @click="selectResponse(proposition,index)" :class=" answered ? check(proposition, index) : ''" v-html="`${index + 1}. ` + proposition.props">
            </li>
          </ul>
        </div>



        <!-- progress -->
        <div class="question-progress" v-if="quiz && (step=='practice' || step=='exam')">
          <div class="progress-label">
            <div class="label-progress"><p>{{ timeLeft }}</p> sec.left</div>
          </div>
          <div class="progress-bar">
            <div class="progress-rate" :style="{ width: timeRemaining + '%' }"></div>
          </div>
        </div>
      </div>

      <!-- Buttons for Audio -->
      <div v-if="quiz">
        <lessonmultiaudio ref="lessonmultiaudio" v-if="isListening && audios && audioType=='audio'" :audioList="audios" :audioType="audioType" :hasAudioEl="hasAudioEl" @playevent="audioPlayEvent"></lessonmultiaudio>
      </div>

      <!-- Footer -->
      <div class="footer-quiz">
        <div class="box-button button-next-done" v-if="quiz" >
            <button class="button" @click="nextQuestion()" :class="answered ? 'button-primary' : 'disabled'">{{ $t('common.button.next') }}</button>
        </div>
      </div>


    </div>


    <div class="container score" v-if="!quiz">
      <div class="heading-content-title">
        <template v-if="step=='listening_practice'">{{ $t('lesson.listening_practice.title') }}</template>
        <template v-else-if="step=='exam'">{{ $t('lesson.exam.title') }}</template>
        <template v-else>{{ $t('lesson.question.title') }}</template>
      </div>
      <div class="box-score">
        <div class="image-score" :class="score_result"></div>
        <div class="score-result" :class="score_result">{{ $t('lesson.question.score.title') }} <p class="score-shown"><span class="score-count">{{score}}</span>/{{questions.length}}</p></div>

        <p class="message">
        <template v-if="score_result == 'perfect'">
          {{ $t('lesson.question.score.perfect.message_1') }}<br>
          {{ $t('lesson.question.score.perfect.message_2') }}
        </template>
        <template v-else-if="score_result == 'pass'">
          {{ $t('lesson.question.score.pass.message_1') }}
        </template>
        <template v-else-if="score_result == 'failure'">
          {{ $t('lesson.question.score.failure.message_1') }}
        </template>

        </p>
      </div>
    </div>

</div>

</template>

<script>

import {appEnv} from './../../config';

import questionLog from '../../mixins/question-log';
import {mapGetters} from 'vuex';

import LessonMultiAudio from './LessonMultiAudio.vue'

export default {
  mixins: [questionLog],
  name: "LessonQuestion",
  components: {
    'lessonmultiaudio': LessonMultiAudio,
  },
  props: {
    step: {
      type: String,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    audios: {
      type: Array
    },
  },
  data(){
    return{
      audioType: 'audio',

      a:0,
      b:1,
      next:true,
      quiz:true,
      score:0,
      progress:0,
      count_timer:null,
      answered:false,
      // next_step:false,
      correct_answerd:false,
      incorrect_answerd:null,
      score_result:null,

      lives_cnt:3,
      timeLimit: 30,
      timePassed: 0,
      fullDashArray: 283,
      colorCodes: {
        info: {
          color: "green"
        },
        warning: {
          color: "orange",
          threshold: 15
        },
        alert: {
          color: "red",
          threshold: 10
        }
      },

      trans_instruction:false,
      authUser: null,
      hasAudioEl: false,
      storage: {},

      questionCount: 0,
    }
  },
  computed: {
    ...mapGetters([
      'selectedLanguage'
    ]),
    isListening() {
      if (this.step == 'listening_practice') {
        return true;
      }
      return false;
    },
    timeLeft() {
      return this.timeLimit - this.timePassed
    },
    timeRemaining() {
      return (this.timePassed / this.timeLimit) * 100
    },
    questionList () {
      const questionSlise = this.questions.slice(this.a,this.b)

      return _.map(questionSlise, (value, index) => {
        let newQuestion = _.cloneDeep(value)
        newQuestion.propositions = _.shuffle(newQuestion.propositions)
        return newQuestion
      })
    }
  },

  watch: {
    answered() {
      if (!this.isListening) {return}
      if (this.answered) {
        this.$refs.lessonmultiaudio.pauseAudio();
      }
    },
    quiz() {
      if (!this.isListening) {return}
      if (!this.quiz) {
        this.$refs.lessonmultiaudio.stopAudio();
      }
    },

  },

  created() {
      this.authUser = this.$store.getters.getAuthUser;

      if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
        this.$router.push({name: 'lesson.introduction'});
      }

      this.answered = false


      this.questionCount = this.$store.getters.lesson_content[this.step].content.questions ? this.$store.getters.lesson_content[this.step].content.questions.length : 0

      if(this.questionCount <= 3) {
        this.lives_cnt = 2
      }
  },

  mounted() {

    this.progress = (100/this.questions.length);
    if (!this.isListening) {
      this.countTime();
    }
  },
  beforeDestroy() {
    clearInterval(this.count_timer);
  },
  methods: {
    changeTrans(key) {
      if (key !== 'ja') {
        this.trans_instruction = !this.trans_instruction
      }
    },

    countTime() {
      let ref = this;

      if (this.answered) return false;

      ref.count_timer = setInterval(function(){
        ref.timePassed++;
        if(ref.timeLimit <= ref.timePassed) {
          clearInterval(ref.count_timer);
          ref.lives_cnt--;
          ref.answered = true;
          ref.nextQuestion();
        }
      }, 1000);
    },

    quizPropositions(quiz) {
      return _.shuffle(quiz.propositions)
    },

    selectResponse(e, index) {

      if(this.count_timer) clearInterval(this.count_timer);

      if (this.answered) {
        return;
      }

      if (e.correct) {
        this.score++;
        this.correct_answerd = true;
        this.$store.dispatch('playSoundEffect', 'correct')
      } else {
        this.lives_cnt--;
        this.incorrect_answerd = index;
        this.$store.dispatch('playSoundEffect', 'incorrect')
      }
      this.answered = true;
    },

    check(status, index) {
      if (status.correct && this.correct_answerd) {
        return 'correct'
      } else if (this.incorrect_answerd == index) {
        return 'incorrect'
      }
    },

    nextQuestion() {

      if (!this.answered) {
        return;
      }

      // exam log
      let question_id = this.$store.getters.lesson_content[this.step].content.questions[this.a].question_id;
      let answered = (this.correct_answerd) ? true : false;
      let selected = (this.incorrect_answerd == null) ? this.incorrect_answerd : this.incorrect_answerd + 1;
      this.questionTempLog(question_id, answered, selected);

      if (this.lives_cnt <= 0) {
        this.quiz = false;
        this.score_result = 'failure';
        this.$emit('scoreresult', this.score_result)
        this.$emit('finquiz')

      } else if (this.questions.length - 1 == this.a) {
        this.quiz = false;
        // this.next_step = true;
        if (this.score == this.questions.length) {
          this.score_result = 'perfect';
        } else if (this.score <= 0) {
          this.score_result = 'failure';
        } else {
          this.score_result = 'pass';
        }
        this.lessonTempLog(this.score_result);

        this.$emit('scoreresult', this.score_result)
        this.$emit('finquiz')
        this.$emit('passedquiz')


        // Update Log
        this.questionLog()

      } else {
        this.progress = this.progress + (100/this.questions.length);
        this.a++;
        this.b++;
        this.timePassed = 0;
        this.answered = false;
        this.correct_answerd = false;
        this.incorrect_answerd = null;

        if (!this.isListening) {
          this.countTime();
        }
      }
    },

    restartQuiz(){
      let to = '';
      if (this.step == 'practice') {
        to = 'lesson.practice';
      } else if (this.step == 'listening_practice') {
        to = 'lesson.listening.practice';
      } else {
        to = 'lesson.exam';
      }
      this.$router.go({name: to})
    },

    completedLesson() {
    },

    audioPlayEvent: function(value) {

    },
  }
}
</script>

<style scoped lang="scss">
.base-timer {
  position: relative;
  width: 75px;
  height: 75px;
  margin: 10px auto; // new
  &__circle {
    fill: none;
    stroke: none;
  }
  &__path-elapsed {
    stroke-width: 7px;
    stroke:grey;
    stroke: #e0e0e0;
  }
  &__label {
    position: absolute;
    width: 75px;
    height: 75px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    stroke: rgb(65, 184, 131); // green
  }
  &__svg {
    transform: scaleX(-1);
  }
  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;
    &.green {
      color: rgb(65, 184, 131);
    }
    &.orange {
      color: orange;
    }
    &.red {
      color: red;
    }
  }
}
</style>
